export var BreakerArrangement;
(function (BreakerArrangement) {
    BreakerArrangement["VERTICAL"] = "VERTICAL";
    BreakerArrangement["HORIZONTAL"] = "HORIZONTAL";
})(BreakerArrangement || (BreakerArrangement = {}));
export var BreakerType;
(function (BreakerType) {
    BreakerType["SINGLE_POLE"] = "SINGLE_POLE";
    BreakerType["DOUBLE_POLE"] = "DOUBLE_POLE";
    BreakerType["THREE_POLE"] = "THREE_POLE";
})(BreakerType || (BreakerType = {}));
export const mapBreakerTypeToPoleNumber = {
    [BreakerType.SINGLE_POLE]: 1,
    [BreakerType.DOUBLE_POLE]: 2,
    [BreakerType.THREE_POLE]: 3,
};
export var PolePhase;
(function (PolePhase) {
    PolePhase["PHASE_A"] = "PHASE_A";
    PolePhase["PHASE_B"] = "PHASE_B";
    PolePhase["PHASE_C"] = "PHASE_C";
})(PolePhase || (PolePhase = {}));
